/*
Import all child theme specific scripts here
*/

//import cards from "./custom/cards.js";
import "./custom/navbar.js"; // Import navbar functionality
// ajax-search.js is enqueued separately in enqueues.php
import "./libs/splide/splide_custom_simple_initialize.js"; // Import and execute team.js
import "./custom/load-more-posts.js"; // Import load more posts functionality
import "./custom/dual-section.js"; // Import dual section functionality
import "./custom/offers-slider.js"; // Import offers slider functionality
import "./custom/destinations-slider.js"; // Import destinations slider functionality
import "./custom/cruise-hero-cabins.js"; // Import cruise hero cabin selection
import "./custom/itinerary-fix.js"; // Fix week-switch stale day panes
import "./custom/deckplans-carousel.js"; // Deckplans mobile prev/next navigation
import "./custom/ship-facilities-carousel.js"; // Ship facilities item carousel
import "./custom/testimonials.js"; // Testimonials slider
import "./custom/blog-posts-slider.js"; // Blog posts slider
import "./custom/accordion.js"; // FAQ accordion toggle
import "./custom/popup-modal.js"; // Bridge: accoms enquire → Pontoon inquiry dialog
